<template>
	<div>
		<div v-if="!by_order">

			<div v-if="isIntegrated()">
				<div class="h-login-form-box" id="container_asi_signin">
					<h3>Log in using your school credentials to view your order history</h3>
					<div class="h-login-form" v-html="login_form_html"></div>
				</div>
				<div class="h-login-form-no-acc">
					<v-btn v-if="byOrder" @click="by_order = true">I don't have an account</v-btn>
				</div>
			</div>
			<div v-else>
				<form action="/account/login.php" method="post">
					<v-text-field solo flat name="username" label="Email or Login"></v-text-field>
					<v-text-field solo flat name="password" label="Password" type="password"></v-text-field>
					<input type="hidden" name="return_url" :value="returnUrl">

					<v-btn color="#7DADED" large round dark type="submit">Log in</v-btn>
					<v-btn v-if="byOrder" @click="by_order = true">I don't have an account</v-btn>
				</form>
			</div>

		</div>
		<div class="h-order-form-box" v-else>
			<h3>Please enter your order info:</h3>
			<form action="/help#/help_with_my_order" method="post">
				<v-text-field solo flat name="email" label="E-mail" type="email"></v-text-field>
				<v-text-field solo flat name="order_id" label="Order Number"></v-text-field>

				<v-btn color="#7DADED" large round dark type="submit">View my order</v-btn>
				<v-btn @click="by_order = false">Return to login form</v-btn>
			</form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LoginForm',

		props: {
			returnUrl: {
				type: String,
				default: '',
			},
			byOrder: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				by_order: false,
				login_form_html: '',
			}
		},

		mounted() {
			const self = this;

			if (self.$globs['login_form']) {
				self.login_form_html = self.$globs['login_form'];
			}
		},

		methods: {
			isIntegrated() {
				return this.$globs['institute_info'] && this.$globs['institute_info']['is_integrated_school'];
			}
		}
	}
</script>

<style scoped lang="less">
	.h-login-form-box {
		width: 460px;
		border: 1px solid #d6d6d6;
		padding: 30px;
		margin-top: 50px;
		background-color: #DDEAFA;

		h3 {
			text-align: center;
			margin-bottom: 20px;
		}
	}

	.h-login-form-no-acc {
		margin-top: 15px;
	}

	.h-order-form-box {
		h3 {
			margin-bottom: 10px;
		}
	}
</style>